import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${
      queryFilter.sort
    },${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/protocolo/itens_protocolo${queryUrl}`)
  },
  insert(data) {
    return axios.post('/protocolo/itens_protocolo', data)
  },
  edit(data) {
    return axios.put(`/protocolo/itens_protocolo/${data.id}`, data)
  },
  delete(id) {
    return axios.delete(`/protocolo/itens_protocolo/${id}`)
  },
}
